export const environment = {

    production: false,

    clientId: '9204121783666917157',

    defaultHostV2: 'api-preprod.mykronoz.com',

    defaultHostV1: 'api.mykronoz.com',

    watchfacesStore: 'https://watchfaces-dev.mykronoz.com/',

    host(service: string) {
        switch (service) {
            case 'v2-accounts':
            case 'v2-challenges':
            case 'v2-community':
            case 'v2-firmwares':
            case 'v2-pairing':
            case 'v2-myscale':
            case 'v2-sleep':
            case 'v2-sports':
            case 'v2-tracking':
            case 'v2-watchfaces':
                return `https://${environment.defaultHostV2}`;
            case 'v1-accounts':
            case 'v1-banner':
            case 'v1-challenges':
            case 'v1-email':
            case 'v1-facebook':
            case 'v1-firmware':
            case 'v1-google':
            case 'v1-news':
            case 'v1-pairing':
            case 'v1-personal':
            case 'v1-sleep':
            case 'v1-sport':
            case 'v1-storage':
            case 'v1-tracking':
            case 'v1-twitter':
            case 'v1-watchface':
                return `https://${environment.defaultHostV1}`;
            default:
                return '';
        }
    },

    legacyHosts: []
};
